import { create } from "zustand";

import type { ModalContentType } from "@/types";

interface ModalState {
  isOpen: boolean;
  type: ModalContentType;
}

interface ModalActions {
  setType: (type: ModalContentType) => void;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

export type ModalStore = ModalState & ModalActions;

const initialDefaultState: ModalState = {
  isOpen: false,
  type: "third-party",
};

export const useModalStore = create<ModalStore>()((set) => ({
  ...initialDefaultState,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setType: (type) => set({ type }),
}));
